<script lang="ts">
	//Design system components
	import { Button, Container, Input, Modal, Text } from '@Shelly/shelly-design-system';
	//Stores
	import { stackedMobileEvents } from 'src/stores/features/ai-model';
import { os } from 'src/stores/session/native-bridge';
	import { authenticateGen2DeviceModal } from 'src/stores/device-runtime/firmware-ui';
	//Services
	import { format } from 'svelte-i18n';
	import {
		authenticate_over_ble_android,
		rpc_over_ble_android,
	} from 'src/services/native_container_requests_android';
	import {
		authenticate_over_ble_ios,
		rpc_over_ble_ios,
	} from 'src/services/native_container_requests_ios';
	import { wait } from 'src/helpers/utilities';
	import { createEventDispatcher } from 'svelte';

	export let isScanOpen = false;

	const dispatch = createEventDispatcher();

	const deviceMac = $authenticateGen2DeviceModal;

	$: showModal = typeof $authenticateGen2DeviceModal !== 'undefined';

	let pass;
	let loading = false;

	const onCloseAuthentication = () => {
		authenticateGen2DeviceModal.set(undefined);
		showModal = false;
	};

	const authenticateOverBluetooth = async () => {
		wait(1000);

		const requestDigestPasswordIndex = $stackedMobileEvents.findIndex(
			(event) => event === 'requestDigestPasswordFromUser',
		);
		const eventBeforeRequestDigestPassword = $stackedMobileEvents[requestDigestPasswordIndex - 1];

		if ($os !== 'IOS') {
			authenticate_over_ble_android(deviceMac, pass);
			if (eventBeforeRequestDigestPassword === 'scanningWiFi')
				rpc_over_ble_android(deviceMac, 'scanWiFi');
		} else {
			authenticate_over_ble_ios(deviceMac, pass);
			if (eventBeforeRequestDigestPassword === 'scanningWiFi')
				rpc_over_ble_ios(deviceMac, 'scanWiFi');
		}

		if (
			['gettingDeviceInformation', 'gettingSettings', 'gettingStatus'].includes(
				eventBeforeRequestDigestPassword,
			)
		) {
			dispatch('save');
		}
		onCloseAuthentication();
	};
</script>

<Modal
	on:close={() => {
		onCloseAuthentication();
		if (isScanOpen) isScanOpen = false;
	}}
	bind:showModal
	title={$format('title_authenticate_device', {
		default: 'Authenticate device',
	})}
	removeScrollPadding
>
	<svelte:fragment slot="content">
		<Container padding="scrollPaddings">
			<Text element="h4" class="mb-m"
				>{$format('device_status_locked', {
					default: 'Device is locked',
				})}</Text
			>
			<Text element="h4" class="mb-m"
				>{$format('auth_cred_prompt', {
					default: 'Please enter the correct device authentication code to unlock it.',
				})}</Text
			>
			<!-- DO NOT REMOVE COMMENT: Padding references -->
			<Input
				a11yProps={{
					iconButtonAriaLabel: $format('input-authenticate-ble-device', {
						default: 'input authenticate ble device',
					}),
				}}
				aria-label={$format('input-authenticate-ble-device', {
					default: 'input authenticate ble device',
				})}
				id="input-authenticate-ble-device"
				class="pb-s"
				bind:value={pass}
				type="password"
				label="*******"
				disabled={loading}
				on:enter={authenticateOverBluetooth}
			/>
		</Container>
	</svelte:fragment>
	<div slot="footer" class="d-flex justify-content-end">
		<Button
			class="width-md-m width-sm-full text-capitalize"
			size="m"
			{loading}
			icon={'fas fa-save'}
			on:click={authenticateOverBluetooth}>{$format('button_save', { default: 'Save' })}</Button
		>
	</div>
</Modal>
